<template>
  <div :class="cn('animate-pulse rounded-md bg-zinc-200/60 dark:bg-zinc-800', props.class)" />
</template>

<script setup>
import { cn } from "@/lib/utils"

const props = defineProps({
  class: { type: String, default: "" },
})
</script>
